import { render, staticRenderFns } from "./KontakKami.vue?vue&type=template&id=511612a8&scoped=true"
import script from "./KontakKami.vue?vue&type=script&lang=js"
export * from "./KontakKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511612a8",
  null
  
)

export default component.exports